export const isFeatureEnabled = (keys, featureFlagsData) => {
    if (!featureFlagsData || !keys) return false;

    // Ensure keys is an array
    const keyPath = Array.isArray(keys) ? keys : [keys];

    let current = featureFlagsData;

    for (const key of keyPath) {
        if (!current[key]) return false; // Key not found
        current = current[key]; // Move deeper
    }

    return Boolean(current);
};
